import React, { useState, useEffect } from "react";
import { app, db, auth, storage } from "../firebase"; // Import auth from firebase
import {
    getFirestore,
    collection,
    addDoc,
} from "firebase/firestore";
import { Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
    getDownloadURL,
    ref,
    uploadBytes,
    getStorage,
} from "firebase/storage"; // Import getDownloadURL and ref from storage

const ScholarshipPost = () => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [eligibility, setEligibility] = useState("");
    const [deadline, setDeadline] = useState("");
    const [link, setLink] = useState("");
    const [link1, setLink1] = useState("");
    const [country, setCountry] = useState("");
    const [password, setPassword] = useState("");
    const [image, setImage] = useState(null);
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const firestoreDb = getFirestore(app); // Use firestoreDb as the variable for getFirestore
    const storageRef = getStorage(app); // Use storage to access storage functions

    useEffect(() => {
        // Any additional setup you may need
    }, []);

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };

    const handleImageUpload = async () => {
        try {
            if (!image) {
                alert("Please select an image");
                return null;
            }

            const storageRef = ref(storage, `images/${image.name}`); // Use storageRef with storage
            await uploadBytes(storageRef, image);
            const imageUrl = await getDownloadURL(storageRef);

            return imageUrl;
        } catch (error) {
            console.error("Error uploading image:", error);
            throw error;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check the password here
        if (password !== "mj1234") {
            alert("Incorrect password. Access denied.");
            return;
        }

        setLoader(true);

        try {
            const imageUrl = await handleImageUpload();

            if (!imageUrl) {
                setLoader(false);
                return;
            }
            const timestamp = new Date();
            const docRef = await addDoc(collection(firestoreDb, "Scholarship"), {
                title: title,
                description: description,
                eligibility: eligibility,
                deadline: deadline,
                link: link, // Add link1 field
                link1: link1, // Add link2 field
                country: country,
                imageUrl: imageUrl,
                timestamp: timestamp,
            });

            setLoader(false);
            setShowModal(true);
            console.log("Document written with ID: ", docRef.id);
        } catch (error) {
            alert(error.message);
            setLoader(false);
        }

        // Clear form fields after submission
        setTitle("");
        setDescription("");
        setEligibility("");
        setDeadline("");
        setLink("");
        setLink1("");
        setCountry("");
        setPassword("");
        setImage(null);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="mb-3">
                        {/* Link to the View Scholarships page */}
                        <Link to="/viewscholarship" className="btn btn-primary btn-block" style={{marginLeft:"20%"}}>
                            View Scholarships
                        </Link>
                    </div>

                    <div className="mb-3">
                        {/* Link to the View Scholarships page */}
                        <Link to="/viewmessage" className="btn btn-primary btn-block" style={{marginLeft:"20%"}}>
                            View Message
                        </Link>
                    </div>
                    <div className="card">

                        <div className="card-body">
                            <h2 className="card-title text-center">Post a Scholarship</h2>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">
                                        Title
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="title"
                                        placeholder="Title"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="description" className="form-label">
                                        Description
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="description"
                                        rows="5"
                                        placeholder="Description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="eligibility" className="form-label">
                                        Eligibility
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="eligibility"
                                        rows="3"
                                        placeholder="Eligibility"
                                        value={eligibility}
                                        onChange={(e) => setEligibility(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="deadline" className="form-label">
                                        Deadline
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="deadline"
                                        placeholder="Deadline"
                                        value={deadline}
                                        onChange={(e) => setDeadline(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="link1" className="form-label">
                                        Link 1
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="link1"
                                        rows="5"
                                        placeholder="Link 1"
                                        value={link}
                                        onChange={(e) => setLink(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="link2" className="form-label">
                                        Link 2
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="link2"
                                        rows="5"
                                        placeholder="Link 2"
                                        value={link1}
                                        onChange={(e) => setLink1(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="country" className="form-label">
                                        Country
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="country"
                                        placeholder="Country"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="image" className="form-label">
                                        Image
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="image"
                                        onChange={handleImageChange}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block"
                                        onClick={handleSubmit}
                                    >
                                        Post Scholarship
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>

            {/* Success Modal */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>Your scholarship post has been submitted 👍</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ScholarshipPost;
